module.exports = __webpack_public_path__ + "img/UNI.8b7971cb.png";